import { ErrorMessage, useField } from 'formik';
import { CustomErrorMessage } from '@src/design-system/error-message';
import { CountryField } from '@shared/fields/country-field';

export function FormikCountryField({
  selectName,
  isInModal = false,
}: {
  selectName: string;
  isInModal?: boolean;
}) {
  const [props, , helpers] = useField(selectName);

  return (
    <>
      <CountryField
        value={props.value}
        onSelect={(c) => helpers.setValue(c.code)}
        isSelected={(c) => props.value === c.code}
        isInModal={isInModal}
      />

      <ErrorMessage
        name={props.name}
        component={CustomErrorMessage}
      />
    </>
  );
}
